// @flow
import * as React from 'react';

import step1 from './step1-v2.png';
import step1_2x from './step1-v2@2x.png';
import step2 from './step2-v2.png';
import step2_2x from './step2-v2@2x.png';
import step3 from './step3-v2.png';
import step3_2x from './step3-v2@2x.png';
import cs from './styles.pcss';
import t from './locale';

export default function HowTo(): React.Node {
  const stepImages = [
    { src: step1, srcSet: `${step1} 1x, ${step1_2x} 2x` },
    { src: step2, srcSet: `${step2} 1x, ${step2_2x} 2x` },
    { src: step3, srcSet: `${step3} 1x, ${step3_2x} 2x` },
  ];
  const stepLabels = ['Sign in', 'Listings', 'Orders'];

  const renderListItem = (index) => (
    <div key={index} className={cs.listElement}>
      <div className={cs.stepIconWrapper}>
        <img
          className={cs.stepIcon}
          src={stepImages[index].src}
          srcSet={stepImages[index].srcSet}
          alt={`step ${index + 1}`}
          loading="lazy"
        />
        <span className={cs.stepLabel} data-step-number={index + 1}>
          {stepLabels[index]}
        </span>
      </div>
      <span className={cs.listElementText}>{t(`steps.${index}`)}</span>
    </div>
  );

  const renderTitle = () => {
    const titleText = t('title');
    const stepsPattern =
      /(\d+\s*(?:steps?|шага|étapes?|passaggi|Schritten?|pasos?|etapas?|krokach|ステップ|방법))/i;
    const match = titleText.match(stepsPattern);

    if (match) {
      const parts = titleText.split(stepsPattern);
      return (
        <h2 className={cs.title}>
          {parts[0]}
          <span className={cs.stepsHighlight}>{match[0]}</span>
          {parts[2]}
        </h2>
      );
    }

    return <h2 className={cs.title}>{titleText}</h2>;
  };

  return (
    <div className={cs.howTo}>
      <div className={cs.howtoWrapper}>
        {renderTitle()}
        <div className={cs.stepsList}>
          {[...Array(3)].map((_, index) => renderListItem(index))}
        </div>
      </div>
    </div>
  );
}
